export default function ClockIcon({ width, height, color }) {
    return (
        <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="Icons">
                <path id="Vector" d="M20.6957 8.08695V5.91305H19.3913V4.60871H18.087V3.30434H15.913V2H8.08677V3.30434H5.91283V4.60867H4.60848V5.91301H3.30408V8.08691L2 8.08703V15.9131H3.30408V18.0869H4.60844V19.3913H5.9128V20.6956H8.08674V22H15.913V20.6957H18.0869V19.3913H19.3913V18.087H20.6956V15.9132H21.1307V15.9131H22V8.08695H20.6957ZM12.8695 11.5652V12.4348H7.652V11.1305H11.5651V4.60871H12.8695V11.5652Z" fill="white" />
            </g>
        </svg>

    );
}